import { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import emailjs from 'emailjs-com';

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Send');
  const [status, setStatus] = useState({});
  
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDangerAlert, setShowDangerAlert] = useState(false);

  const form = useRef();

  const onFormUpdate = (category, value) => {
      setFormDetails({
        ...formDetails,
        [category]: value
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formDetails)
    // setButtonText("Sending...");

    // let response = await fetch("http://localhost:5000/contact", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json;charset=utf-8",
    //   },
    //   body: JSON.stringify(formDetails),
    // });
    // setButtonText("Send");
    // let result = await response.json();

    setFormDetails(formInitialDetails);

    emailjs.sendForm("service_uhx3rqi","template_6e2mqdf",form.current, "ApvPEcQ8qrd4VM4HZ")
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

      // if (result.code === 200) {
      //   setStatus({ succes: true, message: 'Message sent successfully'});
      // } else {
      //   setStatus({ succes: false, message: 'Something went wrong, please try again later.'});
      // }
  };

  const handleButtonClick = () => {
    // Check if any input field is empty
    if (formDetails.firstName === '' || formDetails.lastName === '' || formDetails.email === '' || formDetails.phone === ''|| formDetails.message === '') {
      setShowDangerAlert(true);
      setTimeout(() => {
        setShowDangerAlert(false);
      }, 3000); // Set the duration in milliseconds (3 seconds in this example)
    } else {
      setShowSuccessAlert(true);
      setTimeout(() => {
        setShowSuccessAlert(false);
      }, 3000); // Set the duration in milliseconds (3 seconds in this example)
      }
 };
 

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>Get In Touch</h2>
                <form ref = {form} onSubmit={handleSubmit}>
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" name="firstName" value={formDetails.firstName} placeholder="First Name" onChange={(e) => onFormUpdate('firstName', e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text"  name="lastName" value={formDetails.lastName} placeholder="Last Name" onChange={(e) => onFormUpdate('lastName', e.target.value)}/>
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="email" name="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => onFormUpdate('email', e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="tel" name="phone" value={formDetails.phone} placeholder="Phone No." onChange={(e) => onFormUpdate('phone', e.target.value)}/>
                    </Col>
                    <Col size={12} className="px-1">
                      <textarea rows="6" name="message" value={formDetails.message} placeholder="Message" onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>
                      <button type="submit" onClick={handleButtonClick}><span>{buttonText}</span></button>
                    </Col>
                    {/* {
                      status.message &&
                      <Col>
                        <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                      </Col>
                    } */}
                    {showSuccessAlert && (
                        <div className="mt-3 text-center" id="success">
                          <div className="alert alert-success" role="alert">
                            <strong>Message sent!</strong> I will get back to you as soon as possible.🩷
                          </div>
                        </div>
                      )}

                      {showDangerAlert && (
                        <div className="mt-3 text-center" id="error">
                          <div className="alert alert-danger" role="alert">
                            <strong>Error!</strong> Please fill in all the fields.
                          </div>
                        </div>
                    )}

                  </Row>
                </form>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
